module.exports = __webpack_public_path__ + "assets/img/banner-center5.dcfd4d4b.jpg";